import React from "react";
import { Table as BSTable, Button, Form, Pagination } from "react-bootstrap";

export default function Table({
  data,
  columns,
  onEdit,
  onDelete,
  onResetPassword,
  currentPage,
  perPage,
  setPage,
  setPerPage,
  perPageOptions = [5, 10, 20, 100],
  onRowClick,
}) {
  const startIndex = (currentPage - 1) * perPage;
  const paginated = data.slice(startIndex, startIndex + perPage);
  const totalPages = Math.max(1, Math.ceil(data.length / perPage));

  const renderCell = (row, col) => {
    if (typeof col.accessor === "function") return col.accessor(row);
    return row[col.accessor];
  };

  return (
    <>
      <div className="table-toolbar">
        <div className="table-toolbar__meta">
          {data.length} element{data.length > 1 ? "s" : ""} au total
        </div>
        {setPerPage && (
          <Form.Group className="table-toolbar__size">
            <Form.Label className="mb-0">Lignes par page</Form.Label>
            <Form.Select
              size="sm"
              value={perPage}
              onChange={(e) => {
                setPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              {perPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </div>

      <BSTable
        striped
        bordered
        hover
        responsive
        className={onRowClick ? "table-clickable" : ""}
      >
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={col.Header ?? i}>{col.Header}</th>
            ))}
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {paginated.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 1} className="text-center">
                Aucune donnee a afficher
              </td>
            </tr>
          ) : (
            paginated.map((row, rowIndex) => (
              <tr
                key={row.id ?? rowIndex}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                role={onRowClick ? "button" : undefined}
                tabIndex={onRowClick ? 0 : undefined}
                onKeyDown={
                  onRowClick
                    ? (event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          onRowClick(row);
                        }
                      }
                    : undefined
                }
              >
                {columns.map((col, colIndex) => (
                  <td key={`${row.id ?? rowIndex}-${col.Header ?? colIndex}`}>
                    {renderCell(row, col)}
                  </td>
                ))}

                <td
                  className="d-flex gap-2 flex-wrap"
                  onClick={(event) => event.stopPropagation()}
                >
                  {onEdit && (
                    <Button variant="warning" size="sm" onClick={() => onEdit(row)}>
                      Modifier
                    </Button>
                  )}

                  {onResetPassword && (
                    <Button
                      variant="info"
                      size="sm"
                      onClick={() => onResetPassword(row)}
                    >
                      Reset MDP
                    </Button>
                  )}

                  {onDelete && (
                    <Button variant="danger" size="sm" onClick={() => onDelete(row)}>
                      Supprimer
                    </Button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </BSTable>

      <Pagination className="mt-3">
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => setPage(currentPage - 1)}
        />
        {[...Array(totalPages).keys()].map((num) => (
          <Pagination.Item
            key={num + 1}
            active={num + 1 === currentPage}
            onClick={() => setPage(num + 1)}
          >
            {num + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => setPage(currentPage + 1)}
        />
      </Pagination>
    </>
  );
}
